<dx-box
    #dashboardBox
    *ngIf="loadingComplete"
    height="100%"
    width="100%"
    direction="col"
    (onContentReady)="onViewerReady()"
>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <h2 class="page-header" [ngClass]="{ 'cc-text-center': isSmallScreen }">
                <span *ngIf="!hasDashboards">
                    {{ pageTitle }}
                </span>
                <span *ngIf="hasDashboards">
                    {{ currentDashboard?.name }}
                </span>
                <sup *ngIf="pageHelpLink" class="page-help-link">
                    <a [href]="pageHelpLink" target="_blank" class="fas fa-question-circle"></a>
                </sup>
                <i
                    class="config-menu config-icon config-icon-right dx-theme-border-color dx-theme-accent-as-background-color dx-theme-background-color-as-text-color fas fa-cogs"
                    title="Manage Workspaces"
                    [ngClass]="{
                        'config-icon-with-property-context': !!selectedContext && !!selectedContext.customerId,
                        'config-icon-with-community-context': !!selectedContext && !selectedContext.customerId
                    }"
                    (click)="configMenu.instance.show()"
                ></i>
                <i
                    *ngIf="hasDashboards"
                    class="config-icon config-icon-right dx-theme-border-color cc-white-background fas fa-undo"
                    title="Reset Layout Changes"
                    (click)="onResetLayout()"
                ></i>
                <div class="community-selector config-icon-right" *ngIf="!selectedContext && !isCorporateCiraBook">
                    <app-multi-column-selector
                        #communityMultiSelector
                        [name]="'Community'"
                        [gridSource]="communities"
                        [boxValue]="communityGridBoxValue"
                        [valueExpr]="'communityId'"
                        [displayExpr]="'communityName'"
                        [columnDef]="communityColumns"
                        [dropDownButtonTemplate]="'dropDownButton'"
                        [dropDownOptions]="{ width: 'auto' }"
                        [showClearButton]="true"
                        [navigateToCommunity]="true"
                        [placeholder]="'Select Community...'"
                        [disabled]="loadingVisible"
                        [showHeaderFilters]="true"
                        (gridSelectionEvent)="onCommunitySelection($event)"
                    ></app-multi-column-selector>
                </div>
                <div class="community-selector config-icon-right" *ngIf="isCorporateCiraBook">
                    <dx-select-box
                        #entitySelector
                        width="100%"
                        displayExpr="name"
                        valueExpr="entityId"
                        searchEnabled="true"
                        placeholder="Select Management Company..."
                        [dataSource]="entityList"
                        [wrapItemText]="true"
                        [elementAttr]="{ class: 'cc-selector-container' }"
                        [(value)]="entityValue"
                        (onValueChanged)="onEntitySelection($event)"
                    ></dx-select-box>
                </div>
                <div *ngIf="!!currentDashboard" class="autofit-view-selector config-icon-right">
                    <dx-check-box
                        [text]="currentDashboard.viewMode === 'Scroll' ? 'Auto Fit to Width' : 'Auto Fit to View'"
                        [(value)]="currentDashboard.autoFitView"
                        (onValueChanged)="onAutoFitView()"
                    ></dx-check-box>
                </div>
            </h2>
            <dx-context-menu
                #configMenu
                cssClass="config-menu"
                target=".config-menu"
                [position]="{ my: 'top left', at: 'bottom left' }"
                [hoverStateEnabled]="false"
                [activeStateEnabled]="false"
                [focusStateEnabled]="false"
            >
                <dxi-item>
                    <div *dxTemplate>
                        <dx-form width="100%" height="100%" direction="col" [colCount]="1">
                            <dxi-item itemType="group" [colCount]="2">
                                <dxi-item
                                    *ngIf="isInternalUser"
                                    itemType="button"
                                    horizontalAlignment="left"
                                    verticalAlignment="center"
                                    [buttonOptions]="{
                                        type: 'default',
                                        text: 'Shared Workspaces',
                                        hint: 'Shared Workspaces',
                                        icon: 'far fa-share-square',
                                        onClick: onSharedWorkspace
                                    }"
                                ></dxi-item>
                                <dxi-item *ngIf="!isInternalUser" itemType="empty"></dxi-item>
                                <dxi-item
                                    itemType="button"
                                    horizontalAlignment="right"
                                    verticalAlignment="center"
                                    [buttonOptions]="{
                                        type: 'default',
                                        text: 'Configure New',
                                        hint: 'Configure New',
                                        icon: 'plus',
                                        onClick: onConfigureNew
                                    }"
                                ></dxi-item>
                            </dxi-item>
                            <dxi-item itemType="empty" [visible]="hasDashboards"></dxi-item>
                            <dxi-item itemType="group" caption="System Workspaces" [visible]="hasSystemDashboards">
                                <dxi-item *ngFor="let item of systemDashboards; let i = index">
                                    <div *dxTemplate class="config-menu-item">
                                        <a
                                            class="menu-text dx-theme-text-color"
                                            (click)="onView(item)"
                                            [title]="item.name + (item.isDefault ? ' - default' : '')"
                                        >
                                            {{ item.name }}
                                        </a>
                                        <i
                                            class="menu-icon fa-star dx-theme-accent-as-text-color"
                                            [ngClass]="{ fas: item.isDefault, far: !item.isDefault }"
                                            (click)="onMarkDefault(item)"
                                        ></i>
                                        <i
                                            *ngIf="isITUser"
                                            title="Edit Workspace"
                                            class="menu-icon fas fa-edit dx-theme-accent-as-text-color"
                                            (click)="onEdit(item)"
                                        ></i>
                                        <i
                                            *ngIf="isITUser"
                                            title="Delete Workspace"
                                            class="menu-icon fas fa-trash-alt cc-text-required"
                                            (click)="onDelete(item)"
                                        ></i>
                                    </div>
                                </dxi-item>
                            </dxi-item>
                            <dxi-item itemType="empty" [visible]="hasSystemDashboards"></dxi-item>
                            <dxi-item
                                itemType="group"
                                [caption]="hasSystemDashboards ? 'Custom Workspaces' : undefined"
                                [visible]="hasUserDashboards"
                            >
                                <dxi-item *ngFor="let item of userDashboards; let i = index">
                                    <div *dxTemplate class="config-menu-item">
                                        <a
                                            class="menu-text dx-theme-text-color"
                                            (click)="onView(item)"
                                            [title]="
                                                item.name +
                                                (item.hasSharedWorkspace ? ' (Shared)' : '') +
                                                (item.isDefault ? ' - Default' : '')
                                            "
                                        >
                                            {{ item.name }}
                                            <sup
                                                *ngIf="item.hasSharedWorkspace"
                                                class="menu-text-small fas fa-hashtag"
                                            ></sup>
                                        </a>
                                        <i
                                            title="Make Default Workspace"
                                            class="menu-icon fa-star dx-theme-accent-as-text-color"
                                            [ngClass]="{ fas: item.isDefault, far: !item.isDefault }"
                                            (click)="onMarkDefault(item)"
                                        ></i>
                                        <i
                                            title="Edit Workspace"
                                            class="menu-icon fas fa-edit dx-theme-accent-as-text-color"
                                            (click)="onEdit(item)"
                                        ></i>
                                        <i
                                            title="Delete Workspace"
                                            class="menu-icon fas fa-trash-alt cc-text-required"
                                            (click)="onDelete(item)"
                                        ></i>
                                    </div>
                                </dxi-item>
                            </dxi-item>
                        </dx-form>
                    </div>
                </dxi-item>
            </dx-context-menu>
        </div>
    </dxi-item>

    <dxi-item [ratio]="1" *ngIf="hasDashboards && currentDashboard?.viewMode === 'Carousel'">
        <dx-scroll-view
            width="100%"
            height="100%"
            [direction]="scrollDirection"
            [disabled]="isFullScreen"
            [showScrollbar]="showScrollbar ? scrollbarPreference : 'never'"
        >
            <dx-multi-view
                width="100%"
                height="100%"
                [selectedIndex]="multiViewIndex"
                [dataSource]="currentDashboard?.dashboardSections"
                [loop]="false"
                [swipeEnabled]="false"
                [animationEnabled]="true"
            >
                <div *dxTemplate="let section of 'item'">
                    <div
                        [style.width.px]="maximumOf(section.minWidth, viewerWidth, totalWidth)"
                        [style.height.px]="maximumOf(section.minHeight, viewerHeight, totalHeight)"
                    >
                        <ng-container
                            [ngTemplateOutlet]="dashboardTemplate"
                            [ngTemplateOutletContext]="{ data: section }"
                        ></ng-container>
                    </div>
                </div>
            </dx-multi-view>
        </dx-scroll-view>
    </dxi-item>

    <dxi-item [ratio]="1" *ngIf="hasDashboards && currentDashboard?.viewMode === 'Scroll'">
        <dx-scroll-view
            width="100%"
            height="100%"
            [direction]="scrollDirection"
            [disabled]="isFullScreen"
            [showScrollbar]="showScrollbar ? scrollbarPreference : 'never'"
        >
            <as-split
                direction="vertical"
                gutterSize="5"
                unit="pixel"
                [useTransition]="true"
                [style.width.px]="totalWidth"
                [style.height.px]="totalHeight"
                [disabled]="true"
            >
                <as-split-area
                    [minSize]="section.minHeight"
                    [maxSize]="section.minHeight"
                    [size]="section.minHeight"
                    *ngFor="let section of currentDashboard?.dashboardSections; let idx = index"
                >
                    <div class="scrollview-content" [style.height.px]="section.minHeight">
                        <ng-container
                            [ngTemplateOutlet]="dashboardTemplate"
                            [ngTemplateOutletContext]="{ data: section }"
                        ></ng-container>
                    </div>
                </as-split-area>
            </as-split>
        </dx-scroll-view>
    </dxi-item>

    <dxi-item
        baseSize="auto"
        *ngIf="hasDashboards && currentDashboard?.noOfSections > 1 && currentDashboard?.viewMode === 'Carousel'"
    >
        <dx-toolbar width="100%" class="carousel-icons-toolbar dx-theme-border-color">
            <dxi-item location="center" *ngFor="let section of currentDashboard?.dashboardSections; let idx = index">
                <div *dxTemplate>
                    <dx-button
                        type="default"
                        stylingMode="text"
                        [icon]="multiViewIndex === idx ? 'fas fa-circle' : 'far fa-circle'"
                        (onClick)="onCarouselViewNavigationClick(idx)"
                    ></dx-button>
                </div>
            </dxi-item>
        </dx-toolbar>
    </dxi-item>

    <dxi-item [ratio]="1" class="cc-white-background" *ngIf="!hasDashboards">
        <ng-content></ng-content>
    </dxi-item>
</dx-box>

<ng-template #dashboardTemplate let-section="data">
    <app-dynamic-dashboard
        [editMode]="false"
        [dashboardItems]="section.dashboardItems"
        [direction]="section.direction"
        [layout]="section.layout"
        [viewMode]="currentDashboard?.viewMode"
        [autoFitView]="currentDashboard?.autoFitView"
        (onWidgetChange)="onUpdateWidget()"
        (onResize)="onResizeWidget()"
        (onFullScreen)="onFullScreen($event)"
    ></app-dynamic-dashboard>
</ng-template>

<app-dashboard-creator
    *ngIf="!!selectedDashboard"
    [visible]="configVisible"
    [dashboards]="systemDashboards.concat(userDashboards)"
    [dashboard]="selectedDashboard"
    (onCancel)="onCancel($event)"
    (onSave)="onSave($event)"
></app-dashboard-creator>

<app-shared-workspaces
    *ngIf="sharedWorkspaceVisible"
    [visible]="sharedWorkspaceVisible"
    (onImport)="onImportSharedWorkspace($event)"
    (onEdit)="onEditSharedWorkspace($event)"
    (onDelete)="onDeleteSharedWorkspace($event)"
    (onClose)="onCloseSharedWorkspace()"
></app-shared-workspaces>

<app-dashboard-rename
    *ngIf="showRenameWorkspacePopup"
    [workspaceName]="workspaceName"
    (onClose)="onRenameWorkspaceClose($event)"
></app-dashboard-rename>
